import { render } from "./ProposalInProgressPage.vue?vue&type=template&id=66f5d16f&scoped=true"
import script from "./ProposalInProgressPage.vue?vue&type=script&lang=js"
export * from "./ProposalInProgressPage.vue?vue&type=script&lang=js"

import "./ProposalInProgressPage.vue?vue&type=style&index=0&id=66f5d16f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f5d16f"]])

export default __exports__